var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-checkbox',{class:{mandatory:_vm.isMandatory},attrs:{"disabled":_vm.isDisabled || _vm.tab == -1},on:{"input":_vm.questionAnswered},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}},[_vm._v(" "+_vm._s(_vm.question)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }